import script from "./NavMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./NavMenu.vue?vue&type=script&setup=true&lang=js"

import "./NavMenu.vue?vue&type=style&index=0&id=65da190a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65da190a"]])

export default __exports__